import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FormColorStatusDirective } from './../../../directives/color-status.directive';
import { AutocompleteInput } from './../../../models/inputs/autocomplete-input';
import { prefixInput } from './../../../utils';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
	selector: 'app-autocomplete-input',
	template: `
		<ng-container
			[ngTemplateOutlet]="
				control.bindObject ? bindObject : bindLabelValue
			"
		></ng-container>

		<ng-template #bindLabelValue>
			<ng-select
				[labelForId]="controlId"
				class="body-append"
				bindLabel="label"
				bindValue="value"
				appendTo="body"
				[minTermLength]="control.minTermLength"
				[typeToSearchText]="control.typeToSearchText | translate"
				[notFoundText]="control.notFoundText | translate"
				[typeahead]="control.typeahead"
				[clearable]="control.clearable"
				[multiple]="control.multiple"
				[searchable]="control.searchable"
				[loading]="control.loading"
				[items]="control.options | async"
				[formControl]="control"
				[placeholder]="control.placeholder | translate"
				[appColorStatus]="control.colorStatus"
			>
			</ng-select>
		</ng-template>

		<ng-template #bindObject>
			<ng-select
				[labelForId]="controlId"
				class="body-append"
				appendTo="body"
				[minTermLength]="control.minTermLength"
				[typeToSearchText]="control.typeToSearchText | translate"
				[notFoundText]="control.notFoundText | translate"
				[typeahead]="control.typeahead"
				[clearable]="control.clearable"
				[multiple]="control.multiple"
				[searchable]="control.searchable"
				[loading]="control.loading"
				[items]="control.options | async"
				[formControl]="control"
				[placeholder]="control.placeholder | translate"
				[appColorStatus]="control.colorStatus"
			>
			</ng-select>
		</ng-template>
	`,
	standalone: true,
	imports: [
		NgTemplateOutlet,
		NgSelectModule,
		ReactiveFormsModule,
		FormColorStatusDirective,
		AsyncPipe,
		TranslateModule
	]
})
export class AutocompleteInputComponent extends BaseInputComponent {
	@Input({ required: true }) control: AutocompleteInput;
	@Input({ transform: prefixInput }) controlId: string = '';
}
